/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

  export function meevoAutoCapitalizationFilter(): angular.IFilterService {
    const filter = (input: any) => {

      if (!input) {
        return "";
      }
        
//      return input.toString().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
      return input.toString().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1); });
    };
    return filter;
  }


  angular.module("meevo.components.filters")
      .filter("meevoAutoCapitalization", meevoAutoCapitalizationFilter);
}
